import React from 'react'
import { mdiClose, mdiMagnify } from '@mdi/js'
import { Formik, Form as FormikForm } from 'formik'
import Form from '@components/Common/Form'
import Button from '@components/Common/Button'
import ButtonGroup from '@components/Common/Button/Group'
import { FormSearchProps } from './types'
import { formSearchValues } from './config'

const FormSearch: React.FC <FormSearchProps> = ({ handleSearch, handleReset, getData, loading }) => {

    return(

        <>
            <Formik
                initialValues = {formSearchValues}
                onSubmit = {v => {
                    getData(v)
                }}
            >
                {({ values }) => (
                    <FormikForm>
                        <Form.Container padding = {false}>
                            <Form.Row columns = {4} grid = "auto auto auto auto">
                                <Form.Group
                                    label = "Pesquisar"
                                    inputName = "valorBusca"
                                    inputID = "valorBusca"
                                    onChange = {() => {
                                        if(values.valorBusca !== '' && !!handleSearch){
                                            handleSearch(values.valorBusca)
                                        }
                                    }}
                                />
                                <Form.Group
                                    label = "Data de início"
                                    inputName = "dtInicio"
                                    inputID = "dtInicio"
                                    inputType = "date"
                                />
                                <Form.Group
                                    label = "Data de fim"
                                    inputName = "dtFim"
                                    inputID = "dtFim"
                                    inputType = "date"
                                />

                                <ButtonGroup>
                                    <Button
                                        icon = {mdiMagnify}
                                        loading = {loading}
                                        status = "success"
                                        type = "submit"
                                    />
                                    <Button
                                        icon = {mdiClose}
                                        type = "reset"
                                        status = "error"
                                        onClick = {handleReset}
                                    />
                                </ButtonGroup>
                            </Form.Row>
                        </Form.Container>
                    </FormikForm>
                )}
            </Formik>
        </>

    )

}

export default FormSearch